import React from "react";

import { Row, Col, Space } from "antd";
import { FaInstagram, FaLinkedinIn, FaFacebook } from "react-icons/fa";
import Logo from "../img/logo_blanco.svg";
import LogoCessi from "../img/cessi.png";
import { useLocation } from "react-router-dom";
const enlaces = {
  "/": [
    { text: "Nosotros", url: "/#quienesSomos" },
    { text: "Servicios", url: "/#servicios" },
    { text: "Productos", url: "/#productos" },
    { text: "Enviá tu CV", url: "/#enviarCV" },
    { text: "Contacto", url: "/#contacto" },
  ],
  "/desarrollo": [
    { text: "Servicios", url: "/desarrollo#servicios" },
    { text: "Asistentes virtuales", url: "/desarrollo#asistentesVirtuales" },
    { text: "Casos de éxito", url: "/desarrollo#casosExito" },
    { text: "Partners", url: "/desarrollo#partners" },
    { text: "Contacto", url: "/desarrollo#contacto" },
  ],
  "/infraestructura": [
    { text: "Desarrollo", url: "/desarrollo" },
    { text: "Servicios", url: "/infraestructura#serviciosInfraestructura" },
    { text: "Integraciones", url: "/infraestructura#integraciones" },
    { text: "Producto", url: "/infraestructura#productosInfraestructura" },
    { text: "Contacto", url: "/infraestructura#contacto" },
  ],
};

export const Footer = () => {
  const location = useLocation();
  const enlacesPagina = enlaces[location.pathname] || [];
  const handleScroll = (url) => {
    const [pathname, hash] = url.split("#");
    if (pathname && pathname !== location.pathname) {
      // Redirige a la página correspondiente
      window.location.href = url;
    } else if (hash) {
      // Si está en la misma página, busca el elemento por ID
      const element = document.getElementById(hash);
      if (element) {
        const offset = 50; // Ajusta este valor según la altura del header u otros elementos
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;
  
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  };
  

  // Determinar el fondo según la ubicación actual
  const getFooterBackground = () => {
    if (location.pathname === "/") {
      return "linear-gradient(90deg, #175E6A, #1B1F28)";
    } else if (location.pathname === "/desarrollo") {
      return "linear-gradient(90deg, #9456D0, #4B2C6A)";
    } else if (location.pathname === "/infraestructura") {
      return "linear-gradient(90deg, #5583BA, #202D70)";
    } else {
      return "linear-gradient(90deg, #175E6A, #1B1F28)";
    }
  };

  return (
    <footer
      className="footer"
      style={{
        color: "white",
        width: "100%",
        padding: "20px 0",
        background: getFooterBackground(),
      }}
    >
      <Row
        style={{
          height: "auto",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Col
          xs={24}
          sm={8}
          md={8}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            marginTop: "1em",
            height: "100%",
          }}
        >
          <Space>
            <a
              href="https://www.instagram.com/fasecuatrotecnologia/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
            >
              <FaInstagram className="iconos-footer" />
            </a>
            <a
              href="https://www.facebook.com/search/top?q=fase%204%20-%20driving%20innovation"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
            >
              <FaFacebook className="iconos-footer" />
            </a>
            <a
              href="https://www.linkedin.com/company/fase-4-conectividad-tecnologia/mycompany/verification/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
            >
              <FaLinkedinIn className="iconos-footer" />
            </a>
          </Space>
          <p
            style={{
              display: "block",
              marginTop: "10px",
              marginBottom: "10px",
            }}
            type="secondary"
          >
            Miembros de
          </p>
          <a
            href="https://cessi.org.ar/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white" }}
          >
            <img
              src={LogoCessi}
              alt="Logo Cessi"
              style={{ height: "2em", marginBottom: "10px" }}
            />
          </a>
        </Col>
        <Col
          xs={24}
          sm={8}
          md={8}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            height: "100%",
          }}
        >
          <p style={{ display: "block", marginBottom: "5px" }}>
            <strong>CONTACTO</strong>
          </p>
          <p style={{ display: "block" }}>Administración +549 2396 416909</p>
          <p style={{ display: "block" }}>Soporte IT +549 2396 628434</p>
          <p style={{ display: "block" }}>
            Soporte desarrollo +549 2396 601177
          </p>
          <a
            href="https://www.google.com/maps/search/?api=1&query=Rivarola+18,+Pehuaj%C3%B3"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "white" }}
          >
            <p style={{ display: "block" }}>
              Pehuajó - Pcia. Bs.As. - Argentina
            </p>
          </a>
          <a
            href="mailto:administracion@fasecuatro.com.ar"
            style={{ textDecoration: "none", color: "white" }}
          >
            <p style={{ display: "block" }}>administracion@fasecuatro.com.ar</p>
          </a>
        </Col>
        <Col
          xs={24}
          sm={8}
          md={8}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            height: "100%",
          }}
        >
          <p style={{ display: "block", marginBottom: "5px" }}>
            <strong>ENLACES</strong>
          </p>
          {enlacesPagina.map((enlace, index) => (
            <a
              key={index}
              href={enlace.url}
              onClick={(e) => {
                e.preventDefault();
                handleScroll(enlace.url);
              }}
              style={{
                color: "white",
                cursor: "pointer",
                margin: "0.5px 0",
                textDecoration: "none",
              }}
            >
              {enlace.text}
            </a>
          ))}
        </Col>
      </Row>
      <a
        href="https://fasecuatro.com.ar/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "white" }}
      >
        <p style={{ display: "block", textAlign: "center", marginTop: "1em" }}>
          Diseñado y desarrollado por Fase Cuatro SAS
        </p>
      </a>
    </footer>
  );
};
